import { getDownloadURL, getStorage, ref } from 'firebase/storage'
import { useEffect, useState } from 'react'

export const useFileDownloadUrl = (path?: string) => {
  const [downloadUrl, setDownloadUrl] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchDownloadUrl = async () => {
      setLoading(true)
      if (!path) {
        setDownloadUrl(null)
        setLoading(false)
        return
      }
      try {
        const downloadUrl = await getDownloadURL(ref(getStorage(), path))
        setDownloadUrl(downloadUrl)
        setLoading(false)
      } catch (error) {
        console.error('Error fetching download URL:', error)
        setDownloadUrl(null)
        setLoading(false)
      }
    }
    fetchDownloadUrl()
  }, [path])

  return { downloadUrl, loading }
}
